import { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';
import SehirIlceSecici from '../components/SehirIlceSecici';

export default function SiparisDetay() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { profil } = useAuth();
  const [siparis, setSiparis] = useState(null);
  const [kalemler, setKalemler] = useState([]);
  const [dekontlar, setDekontlar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [odemeModal, setOdemeModal] = useState(false);
  const [odemeForm, setOdemeForm] = useState({ tutar: '', odeme_turu: 'banka', not_: '' });
  const [odemeSekmesi, setOdemeSekmesi] = useState('temsilci_yukle');
  const [dekontDosyalar, setDekontDosyalar] = useState([]);
  const [dekontDosya, setDekontDosya] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [kargoYukleniyor, setKargoYukleniyor] = useState(false);
  const dosyaRef = useRef();
  const [kargoModal, setKargoModal] = useState(false);
  const [takipSorguluyor, setTakipSorguluyor] = useState(false);
  const [musteriDuzenleModal, setMusteriDuzenleModal] = useState(false);
  const [musteriForm, setMusteriForm] = useState({});
  const [kargoForm, setKargoForm] = useState({ kargo_kodu: '', elden_teslim: false, teslim_notu: '', kargo_firma_id: '' });
  const [kargoFirmalar, setKargoFirmalar] = useState([]);
  const [kargoLoglari, setKargoLoglari] = useState([]);

  // ─── ÜRÜN EKLEME STATE ───
  const [urunModal, setUrunModal] = useState(false);
  const [tumUrunler, setTumUrunler] = useState([]);
  const [stokMap, setStokMap] = useState({});
  const [urunArama, setUrunArama] = useState('');
  const [modalAltGrup, setModalAltGrup] = useState(''); // Modal için alt grup filtresi
  const [ekSepet, setEkSepet] = useState([]); // { urun, miktar, fiyat, komisyon }
  const [urunYukleniyor, setUrunYukleniyor] = useState(false);
  const [urunHata, setUrunHata] = useState('');

  const [altTemsilciOran, setAltTemsilciOran] = useState(null);
  const [kkLinkModal, setKkLinkModal] = useState(false);
  const [kkLink, setKkLink] = useState('');

  useEffect(() => { fetchData(); fetchAltTemsilciOran(); }, [id]);

  async function fetchAltTemsilciOran() {
    if (!profil?.id) return;
    const { data } = await supabase.from('kullanicilar').select('ust_temsilci_id, alt_temsilci_komisyon_orani').eq('id', profil.id).maybeSingle();
    if (data?.ust_temsilci_id) setAltTemsilciOran(data.alt_temsilci_komisyon_orani || 75);
  }

  async function fetchData() {
    // musteriler join'i FK sorunu yarattığı için ayrı çekiyoruz
    const { data: s, error: sErr } = await supabase
      .from('siparisler')
      .select('*, firmalar(ad), depolar(ad), kargo_firmalari(ad, kod)')
      .eq('id', id)
      .maybeSingle();
    if (sErr) { console.error('Sipariş yüklenirken hata:', sErr); setLoading(false); return; }
    if (!s) { setSiparis(null); setLoading(false); return; }

    // Müşteriyi ayrı çek
    let musteriData = null;
    if (s.musteri_id) {
      const { data: m } = await supabase.from('musteriler').select('*').eq('id', s.musteri_id).maybeSingle();
      musteriData = m;
    }

    // Temsilciyi ayrı çek (join PGRST200 hatası verdiği için ayrı sorgu)
    let temsilciData = null;
    if (s.temsilci_id) {
      const { data: t } = await supabase.from('kullanicilar').select('ad, soyad').eq('id', s.temsilci_id).maybeSingle();
      temsilciData = t;
    }
    setSiparis({ ...s, musteriler: musteriData, kullanicilar: temsilciData });

    const [{ data: k }, { data: d }, { data: kf }] = await Promise.all([
      supabase.from('siparis_kalemleri').select('*, urunler(ad, grup, alt_grup)').eq('siparis_id', id),
      supabase.from('odeme_dekontlari').select('*').eq('siparis_id', id).order('created_at', { ascending: false }),
      supabase.from('kargo_firmalari').select('*').eq('aktif', true),
    ]);
    setKalemler(k || []);
    setDekontlar(d || []);
    setKargoFirmalar(kf || []);
    const varsayilan = (kf || []).find(f => f.varsayilan);
    if (varsayilan) setKargoForm(f => ({ ...f, kargo_firma_id: varsayilan.id }));
    setLoading(false);
  }

  async function fetchKargoFirmalar() {
    const { data } = await supabase.from('kargo_firmalari').select('*').eq('aktif', true);
    setKargoFirmalar(data || []);
    const varsayilan = (data || []).find(f => f.varsayilan);
    if (varsayilan) setKargoForm(f => ({ ...f, kargo_firma_id: varsayilan.id }));
  }

  // ─── ÜRÜN EKLEME FONKSİYONLARI ───
  async function urunModalAc() {
    setUrunArama('');
    setModalAltGrup('');
    setEkSepet([]);
    setUrunHata('');

    // Temsilci ise sadece yetkili firmaların ürünleri
    let urunQuery = supabase.from('urunler').select('*, firmalar(ad)').eq('aktif', true).order('ad');
    if (profil?.rol === 'temsilci') {
      const { data: yetkiler } = await supabase.from('temsilci_firma_yetki').select('firma_id').eq('kullanici_id', profil.id);
      const yetkiliIds = (yetkiler || []).map(y => y.firma_id);
      if (yetkiliIds.length > 0) {
        urunQuery = urunQuery.in('firma_id', yetkiliIds);
      } else {
        setTumUrunler([]);
        setUrunModal(true);
        return;
      }
    }

    const [{ data: u }, { data: s }] = await Promise.all([
      urunQuery,
      siparis.depo_id
        ? supabase.from('depo_stok').select('urun_id, miktar').eq('depo_id', siparis.depo_id)
        : { data: [] },
    ]);

    const map = {};
    (s || []).forEach(st => { map[st.urun_id] = st.miktar; });
    setStokMap(map);
    setTumUrunler(u || []);
    setUrunModal(true);
  }

  const FIPGL23_ID = 'acb52946-e2a8-4fac-84db-04865b85f944';
  const BROILER_ID = '408634a3-a463-43e8-b01e-2e55ce7ad9fb';

  function birimFiyat(urun) {
    if (urun.firma_id === FIPGL23_ID) return urun.banka_fiyat_kdvsiz || 0;
    if (siparis.odeme_turu === 'kredi_karti') return urun.kk_fiyat_kdvli || 0;
    return urun.banka_fiyat_kdvsiz || 0;
  }

  function komisyonHesapla(urun, miktar) {
    if (urun.komisyonsuz) return 0;
    const fiyat = birimFiyat(urun);
    const oran = (urun.firma_id === FIPGL23_ID || siparis.musteri_tipi !== 'kurumsal')
      ? urun.bireysel_komisyon
      : urun.kurumsal_komisyon;
    return (fiyat * miktar) * ((oran || 0) / 100);
  }

  function ekSepeteEkle(urun) {
    ekSepeteEkleDetay(urun, 'veteriner', siparis.odeme_turu);
  }

  function ekSepeteEkleDetay(urun, grup, odemeTuru) {
    const stok = stokMap[urun.id];
    if (siparis.depo_id && (stok === undefined || stok === 0)) {
      setUrunHata(`⛔ "${urun.ad}" ürününün depoda stoğu YOK.`);
      return;
    }
    setUrunHata('');
    const gGrup = grup || 'veteriner';
    const gTuru = odemeTuru || siparis.odeme_turu;

    // Fiyat — gruba ve ödeme türüne göre
    let fiyat = 0;
    if (urun.firma_id === FIPGL23_ID) {
      fiyat = gGrup === 'hasta_yakini' ? (urun.hya_banka_fiyat || 0) : (urun.banka_fiyat_kdvsiz || 0);
    } else if (urun.firma_id === BROILER_ID) {
      fiyat = birimFiyat(urun);
    } else {
      if (gTuru === 'kredi_karti') fiyat = gGrup === 'hasta_yakini' ? (urun.hya_kk_fiyat || 0) : (urun.kk_fiyat_kdvli || 0);
      else fiyat = gGrup === 'hasta_yakini' ? (urun.hya_banka_fiyat || 0) : (urun.banka_fiyat_kdvsiz || 0);
    }

    // Komisyon oranı — gruba ve ödeme türüne göre
    let oran = 0;
    if (urun.firma_id === FIPGL23_ID) {
      oran = urun.bireysel_komisyon || 0;
    } else {
      if (gTuru === 'kredi_karti') {
        oran = gGrup === 'hasta_yakini' ? (urun.hya_kurumsal_komisyon || urun.kurumsal_komisyon || 0) : (urun.kurumsal_komisyon || 0);
      } else {
        oran = gGrup === 'hasta_yakini' ? (urun.hya_bireysel_komisyon || urun.bireysel_komisyon || 0) : (urun.bireysel_komisyon || 0);
      }
    }
    const komisyon = urun.komisyonsuz ? 0 : fiyat * (oran / 100);
    const sepetKey = urun.id + '_' + gGrup + '_' + gTuru;

    setEkSepet(prev => {
      const mevcut = prev.find(i => i.sepetKey === sepetKey);
      if (mevcut) return prev.map(i => i.sepetKey === sepetKey
        ? { ...i, miktar: i.miktar + 1, komisyon: urun.komisyonsuz ? 0 : fiyat * (i.miktar + 1) * (oran / 100) }
        : i);
      return [...prev, { sepetKey, urun, miktar: 1, fiyat, komisyon, komisyonOrani: oran, grup: gGrup, odemeTuru: gTuru }];
    });
  }

  function ekSepetMiktarGuncelle(sepetKey, yeniMiktar) {
    const miktar = parseInt(yeniMiktar);
    if (isNaN(miktar) || miktar <= 0) {
      setEkSepet(prev => prev.filter(i => i.sepetKey !== sepetKey));
      return;
    }
    setEkSepet(prev => prev.map(i => i.sepetKey === sepetKey
      ? { ...i, miktar, komisyon: i.urun.komisyonsuz ? 0 : i.fiyat * miktar * ((i.komisyonOrani || 0) / 100) }
      : i));
  }

  async function ekUrunleriKaydet() {
    if (ekSepet.length === 0) return;
    setUrunYukleniyor(true);

    // Yeni kalemleri ekle
    const yeniKalemler = ekSepet.map(({ urun, miktar, fiyat, komisyon, komisyonOrani }) => ({
      siparis_id: id,
      urun_id: urun.id,
      miktar,
      birim_fiyat: fiyat,
      toplam: fiyat * miktar,
      komisyon_orani: komisyonOrani || 0,
      komisyon_tutari: komisyon,
    }));
    await supabase.from('siparis_kalemleri').insert(yeniKalemler);

    // Stoktan düş
    if (siparis.depo_id) {
      for (const { urun, miktar } of ekSepet) {
        const mevcutStok = stokMap[urun.id] || 0;
        const yeniStok = Math.max(0, mevcutStok - miktar);
        await supabase.from('depo_stok').upsert(
          { depo_id: siparis.depo_id, urun_id: urun.id, miktar: yeniStok },
          { onConflict: 'depo_id,urun_id' }
        );
        await supabase.from('stok_hareketleri').insert({
          depo_id: siparis.depo_id, urun_id: urun.id, hareket_tipi: 'cikis',
          miktar, onceki_stok: mevcutStok, sonraki_stok: yeniStok,
          aciklama: `Sipariş #${siparis.siparis_no} — ek ürün eklendi`,
        });
      }
    }

    // Sipariş toplamlarını güncelle (mevcut + eklenen)
    const mevcutTutar = kalemler.reduce((a, k) => a + (k.toplam || 0), 0);
    const mevcutKomisyon = kalemler.reduce((a, k) => a + (k.komisyon_tutari || 0), 0);
    const mevcutMaliyet = kalemler.reduce((a, k) => a + ((k.maliyet || 0) * (k.miktar || 1)), 0);
    const ekTutar = ekSepet.reduce((a, { fiyat, miktar }) => a + fiyat * miktar, 0);
    const ekKomisyon = ekSepet.reduce((a, { komisyon }) => a + komisyon, 0);
    const ekMaliyet = ekSepet.reduce((a, { urun, miktar }) => a + (urun.maliyet || 0) * miktar, 0);

    const yeniTutar = mevcutTutar + ekTutar;
    const yeniKomisyon = mevcutKomisyon + ekKomisyon; // tam komisyon
    const yeniMaliyet = mevcutMaliyet + ekMaliyet;

    // Alt temsilci ise siparisler.toplam_komisyon = altPay
    const altOranEk = altTemsilciOran !== null ? (altTemsilciOran / 100) : 1;
    const yazilacakKomEk = yeniKomisyon * altOranEk;

    await supabase.from('siparisler').update({
      toplam_tutar: yeniTutar,
      toplam_komisyon: yazilacakKomEk,
      toplam_maliyet: yeniMaliyet,
      net_kar: yeniTutar - yazilacakKomEk - yeniMaliyet,
    }).eq('id', id);

    // ust_temsilci_komisyonlar güncelle
    if (altTemsilciOran !== null) {
      const ustPayEk = yeniKomisyon * ((100 - altTemsilciOran) / 100);
      await supabase.from('ust_temsilci_komisyonlar').update({
        toplam_komisyon: yeniKomisyon,
        ust_temsilci_payi: ustPayEk,
        alt_temsilci_payi: yazilacakKomEk,
      }).eq('siparis_id', id);
    }

    setUrunModal(false);
    setUrunYukleniyor(false);
    fetchData();
  }

  // ─── MEVCUT FONKSİYONLAR ───
  async function durumGuncelle(yeniDurum) {
    await supabase.from('siparisler').update({ siparis_durumu: yeniDurum }).eq('id', id);
    fetchData();
  }

  async function kargoGuncelle() {
    const update = {};
    setKargoYukleniyor(true);

    if (kargoForm.elden_teslim) {
      update.siparis_durumu = 'teslim';
      update.kargo_kodu = kargoForm.teslim_notu ? `Elden Teslim: ${kargoForm.teslim_notu}` : 'Elden Teslim';
      update.kargo_durumu = 'teslim_edildi';
      update.kargo_teslim_tarihi = new Date().toISOString();
    } else {
      // Yurtiçi AÖ bilgisi varsa ve takip no girilmemişse otomatik barkod oluştur
      update.kargo_kodu = kargoForm.kargo_kodu || '';
      update.siparis_durumu = 'kargoda';
      update.kargo_durumu = 'kargoda';
      update.kargo_cikis_tarihi = new Date().toISOString();
      if (kargoForm.kargo_firma_id) update.kargo_firma_id = kargoForm.kargo_firma_id;
    }

    await supabase.from('siparisler').update(update).eq('id', id);
    await supabase.from('kargo_loglari').insert({
      siparis_id: id,
      kargo_firma_id: kargoForm.kargo_firma_id || null,
      islem_yapan: profil?.id,
      takip_no: update.kargo_kodu || null,
      durum: kargoForm.elden_teslim ? 'elden_teslim' : 'kargoya_verildi',
    });
    setKargoYukleniyor(false);
    setKargoModal(false);
    await fetchData();
    // Kargo kaydedilince WhatsApp ile takip no gönder
    if (!kargoForm.elden_teslim && update.kargo_kodu) {
      const onay = window.confirm('Müşteriye kargo takip numarası WhatsApp ile gönderilsin mi?');
      if (onay) {
        const kargoFirmaAdi = kargoFirmalar.find(f => f.id === kargoForm.kargo_firma_id)?.ad || 'Yurtiçi Kargo';
        const tel = siparis.musteriler?.telefon?.replace(/\D/g, '') || '';
        const takipLinki = `\nTakip Linki: https://www.yurticikargo.com/tr/online-servisler/gonderi-sorgula?code=${update.kargo_kodu}`;
        const mesaj = encodeURIComponent(
          `Merhaba ${siparis.musteriler?.ad || ''},\n\n` +
          `#${siparis.siparis_no} numaralı siparişiniz kargoya verilmiştir.\n\n` +
          `Kargo Firması: ${kargoFirmaAdi}\n` +
          `Takip No: ${update.kargo_kodu}` +
          takipLinki +
          `\n\nTeşekkürler.`
        );
        const waUrl = tel
          ? `https://wa.me/90${tel.replace(/^0/, '')}?text=${mesaj}`
          : `https://wa.me/?text=${mesaj}`;
        window.open(waUrl, '_blank');
      }
    }
  }

  function whatsappLinkGonder() {
    if (!siparis) return;
    const odemeUrl = `${window.location.origin}/odeme/${siparis.siparis_no}`;
    const tel = siparis.musteriler?.telefon?.replace(/\D/g, '') || '';
    const mesaj = encodeURIComponent(
      `Merhaba ${siparis.musteriler?.ad || ''},\n\nSiparişiniz hazır. Bilgilerinizi onaylamak için lütfen aşağıdaki linki kullanınız:\n${odemeUrl}\n\nSipariş No: ${siparis.siparis_no}\nTutar: ${(siparis.toplam_tutar || 0).toLocaleString('tr-TR')} ₺\n\nTeşekkürler.`
    );
    const waUrl = tel ? `https://wa.me/90${tel.replace(/^0/, '')}?text=${mesaj}` : `https://wa.me/?text=${mesaj}`;
    window.open(waUrl, '_blank');
  }

  function whatsappFaturaliHavaleGonder() {
    if (!siparis) return;
    const odemeUrl = `${window.location.origin}/faturali-havale/${siparis.siparis_no}`;
    const tel = siparis.musteriler?.telefon?.replace(/\D/g, '') || '';
    const mesaj = encodeURIComponent(
      `Merhaba ${siparis.musteriler?.ad || ''},\n\nFaturalı siparişiniz için ödeme ve fatura bilgi formunu aşağıdaki linkten doldurabilirsiniz:\n${odemeUrl}\n\nSipariş No: ${siparis.siparis_no}\nTutar: ${(siparis.toplam_tutar || 0).toLocaleString('tr-TR')} ₺\n\nTeşekkürler.`
    );
    const waUrl = tel ? `https://wa.me/90${tel.replace(/^0/, '')}?text=${mesaj}` : `https://wa.me/?text=${mesaj}`;
    window.open(waUrl, '_blank');
  }

  async function kkLinkKaydetVeGonder() {
    if (!kkLink.trim()) { alert('Lütfen sanal pos linkini yapıştırın.'); return; }
    // Linki ve tarihi kaydet
    await supabase.from('siparisler').update({
      kk_odeme_linki: kkLink.trim(),
      kk_link_tarihi: new Date().toISOString(),
    }).eq('id', id);
    setKkLinkModal(false);
    // WhatsApp ile gönder
    const odemeUrl = `${window.location.origin}/kk-odeme/${siparis.siparis_no}`;
    const tel = siparis.musteriler?.telefon?.replace(/\D/g, '') || '';
    const mesaj = encodeURIComponent(
      `Merhaba ${siparis.musteriler?.ad || ''},\n\nKredi kartı ile ödeme yapmak için aşağıdaki linki kullanabilirsiniz:\n${odemeUrl}\n\nSipariş No: ${siparis.siparis_no}\nTutar: ${(siparis.toplam_tutar || 0).toLocaleString('tr-TR')} ₺\n\n⚠️ Bu link 24 saat geçerlidir.\n\nTeşekkürler.`
    );
    const waUrl = tel ? `https://wa.me/90${tel.replace(/^0/, '')}?text=${mesaj}` : `https://wa.me/?text=${mesaj}`;
    fetchData();
    window.open(waUrl, '_blank');
  }

  // Kargo takip no ile WhatsApp mesajı gönder
  async function kalemSil(kalemId, urunId, miktar) {
    if (!window.confirm('Bu ürünü siparişten kaldırmak istediğinizden emin misiniz?')) return;
    // Stoku geri yükle
    if (siparis.depo_id) {
      const { data: stok } = await supabase.from('depo_stok').select('miktar').eq('depo_id', siparis.depo_id).eq('urun_id', urunId).maybeSingle();
      const onceki = Number(stok?.miktar) || 0;
      const yeni = onceki + Number(miktar);
      await supabase.from('depo_stok').upsert({ depo_id: siparis.depo_id, urun_id: urunId, miktar: yeni }, { onConflict: 'depo_id,urun_id' });
      await supabase.from('stok_hareketleri').insert({ depo_id: siparis.depo_id, urun_id: urunId, hareket_tipi: 'iade', miktar: Number(miktar), onceki_stok: onceki, sonraki_stok: yeni, aciklama: 'Sipariş kalemi silindi' });
    }
    await supabase.from('siparis_kalemleri').delete().eq('id', kalemId);
    // Sipariş toplamını güncelle
    const { data: kalanKalemler } = await supabase.from('siparis_kalemleri').select('toplam, komisyon_tutari, maliyet, miktar').eq('siparis_id', id);
    const yT = (kalanKalemler || []).reduce((a, x) => a + (x.toplam || 0), 0);
    const yK = (kalanKalemler || []).reduce((a, x) => a + (x.komisyon_tutari || 0), 0);
    const yM = (kalanKalemler || []).reduce((a, x) => a + (x.maliyet || 0) * (x.miktar || 1), 0);
    // Alt temsilci ise siparisler.toplam_komisyon = altPay olmalı
    const altOranKalem = altTemsilciOran !== null ? (altTemsilciOran / 100) : 1;
    const yazilacakKomKalem = yK * altOranKalem;
    await supabase.from('siparisler').update({ toplam_tutar: yT, toplam_komisyon: yazilacakKomKalem, toplam_maliyet: yM, net_kar: yT - yazilacakKomKalem - yM }).eq('id', id);
    if (altTemsilciOran !== null) {
      const ustPayKalem = yK * ((100 - altTemsilciOran) / 100);
      await supabase.from('ust_temsilci_komisyonlar').update({ toplam_komisyon: yK, ust_temsilci_payi: ustPayKalem, alt_temsilci_payi: yazilacakKomKalem }).eq('siparis_id', id);
    }
    fetchData();
  }

  async function musteriDuzenleKaydet() {
    if (!siparis.musteri_id) { alert('Müşteri ID bulunamadı'); return; }
    try {
      const { error: mErr } = await supabase.from('musteriler').update({
        ad: musteriForm.ad,
        telefon: musteriForm.telefon,
        sehir: musteriForm.sehir,
        ilce: musteriForm.ilce,
        adres: musteriForm.adres,
      }).eq('id', siparis.musteri_id);
      if (mErr) { alert('Müşteri güncellenemedi: ' + mErr.message); return; }
      const { error: sErr } = await supabase.from('siparisler').update({
        adres: musteriForm.siparis_adres,
        not_: musteriForm.not_,
      }).eq('id', id);
      if (sErr) { alert('Sipariş güncellenemedi: ' + sErr.message); return; }
      setMusteriDuzenleModal(false);
      fetchData();
    } catch (e) {
      alert('Hata: ' + e.message);
    }
  }

  function whatsappKargoGonder() {
    if (!siparis) return;
    const takipNo = siparis.kargo_kodu || '';
    const kargoFirmaAdi = kargoFirmalar.find(f => f.id === siparis.kargo_firma_id)?.ad || 'Yurtiçi Kargo';
    const tel = siparis.musteriler?.telefon?.replace(/\D/g, '') || '';

    let takipLinki = '';
    if (takipNo && !takipNo.startsWith('Elden')) {
      takipLinki = `\nTakip Linki: https://www.yurticikargo.com/tr/online-servisler/gonderi-sorgula?code=${takipNo}`;
    }

    const mesaj = encodeURIComponent(
      `Merhaba ${siparis.musteriler?.ad || ''},\n\n` +
      `#${siparis.siparis_no} numaralı siparişiniz kargoya verilmiştir.\n\n` +
      `Kargo Firması: ${kargoFirmaAdi}\n` +
      (takipNo ? `Takip No: ${takipNo}` : 'Elden teslim yapılacaktır.') +
      takipLinki +
      `\n\nTeşekkürler.`
    );
    const waUrl = tel
      ? `https://wa.me/90${tel.replace(/^0/, '')}?text=${mesaj}`
      : `https://wa.me/?text=${mesaj}`;
    window.open(waUrl, '_blank');
  }

  async function temsilciDekontYukle(odemeAlindi = false) {
    if (!dekontDosyalar.length) return;
    setYukleniyor(true);
    try {
      for (const dosya of dekontDosyalar) {
        const dosyaAdi = `dekontlar/${siparis.siparis_no}_${Date.now()}_${Math.random().toString(36).slice(2)}.${dosya.name.split('.').pop()}`;
        const { error: upErr } = await supabase.storage.from('dekontlar').upload(dosyaAdi, dosya, { upsert: true });
        if (upErr) throw upErr;
        const { data: urlData } = supabase.storage.from('dekontlar').getPublicUrl(dosyaAdi);
        await supabase.from('odeme_dekontlari').insert({
          siparis_id: id,
          tutar: siparis.toplam_tutar,
          odeme_turu: odemeForm.odeme_turu || 'banka',
          not_: `Sipariş No: ${siparis.siparis_no} — Temsilci tarafından yüklendi`,
          dekont_url: urlData?.publicUrl,
          created_by: profil?.id,
        });
      }
      if (odemeAlindi) {
        await supabase.from('siparisler').update({ odeme_durumu: 'odendi' }).eq('id', id);
      }
      setOdemeModal(false);
      setDekontDosyalar([]);
      fetchData();
    } catch (err) {
      alert('Hata: ' + err.message);
    }
    setYukleniyor(false);
  }

  async function nakitOdemeKaydet() {
    // FIX: Nakit ödemede makbuz fotoğrafı zorunlu değil ama tutar girilmeli
    if (!odemeForm.tutar || parseFloat(odemeForm.tutar) <= 0) {
      alert('Lütfen alınan tutarı girin.');
      return;
    }
    setYukleniyor(true);
    try {
      let dekontUrl = null;
      if (dekontDosya) {
        const dosyaAdi = `dekontlar/${siparis.siparis_no}_nakit_${Date.now()}.${dekontDosya.name.split('.').pop()}`;
        const { error: upErr } = await supabase.storage.from('dekontlar').upload(dosyaAdi, dekontDosya, { upsert: true });
        if (upErr) throw upErr;
        const { data: urlData } = supabase.storage.from('dekontlar').getPublicUrl(dosyaAdi);
        dekontUrl = urlData?.publicUrl;
      }
      await supabase.from('siparisler').update({ odeme_durumu: 'odendi' }).eq('id', id);
      await supabase.from('odeme_dekontlari').insert({
        siparis_id: id,
        tutar: parseFloat(odemeForm.tutar) || siparis.toplam_tutar,
        odeme_turu: 'elden',
        not_: `Ödeme Elden Alınmıştır. Sipariş No: ${siparis.siparis_no}${odemeForm.not_ ? ' — ' + odemeForm.not_ : ''}`,
        dekont_url: dekontUrl,
        created_by: profil?.id,
      });
      setOdemeModal(false);
      setDekontDosya(null);
      fetchData();
    } catch (err) {
      alert('Hata: ' + err.message);
    }
    setYukleniyor(false);
  }

  async function faturaDurumuGuncelle() {
    await supabase.from('siparisler').update({ fatura_durumu: !siparis.fatura_durumu }).eq('id', id);
    fetchData();
  }

  async function handleSil() {
    if (!window.confirm('Bu siparişi silmek istediğinizden emin misiniz?')) return;
    try {
      // Önce ust_temsilci_komisyonlar'ı sil (FK constraint bunu engelliyor)
      await supabase.from('ust_temsilci_komisyonlar').delete().eq('siparis_id', id);
      await supabase.from('kargo_loglari').delete().eq('siparis_id', id);
      await supabase.from('odeme_dekontlari').delete().eq('siparis_id', id);
      await supabase.from('siparis_kalemleri').delete().eq('siparis_id', id);
      await supabase.from('stok_hareketleri').delete().eq('siparis_id', id);

      const { error } = await supabase.from('siparisler').delete().eq('id', id);
      if (error) {
        alert('Silinemedi: ' + error.message + ' | Kod: ' + error.code);
        return;
      }
      navigate('/siparisler');
    } catch (err) {
      alert('Hata: ' + err.message);
    }
  }

  async function takipNoSorgula() {
    setTakipSorguluyor(true);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const res = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/functions/v1/kargo-sorgula`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session?.access_token}`,
          'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY,
        },
        body: JSON.stringify({ siparis_id: id }),
      });
      const result = await res.json();
      if (result.basarili) {
        fetchData();
        alert(`✅ Takip No güncellendi!\nTakip No: ${result.takip_no}`);
      } else {
        alert('❌ ' + result.mesaj);
      }
    } catch (err) {
      alert('Hata: ' + err.message);
    }
    setTakipSorguluyor(false);
  }

  const durumlar = ['alinidi', 'hazirlaniyor', 'kargoda', 'teslim', 'iade', 'iptal'];
  const durumRenk = { alinidi: 'badge-blue', hazirlaniyor: 'badge-yellow', kargoda: 'badge-orange', teslim: 'badge-green', iade: 'badge-red', iptal: 'badge-gray' };
  const isTemsilci = profil?.rol === 'temsilci';

  if (loading) return <div className="loading">Yükleniyor...</div>;
  if (!siparis) return <div className="empty">Sipariş bulunamadı</div>;

  const siparisLinki = `${window.location.origin}/odeme/${siparis.siparis_no}`;

  // Ürün modal filtrelenmiş liste
  const filtreliUrunler = tumUrunler.filter(u =>
    (!urunArama || u.ad.toLowerCase().includes(urunArama.toLowerCase())) &&
    (!modalAltGrup || (u.alt_grup || 'Diğer').trim() === modalAltGrup)
  );
  const altGruplar = [...new Set(filtreliUrunler.map(u => (u.alt_grup || 'Diğer').trim()))].sort();

  return (
    <>
      <div className="page-header">
        <div>
          <button className="btn btn-ghost btn-sm" onClick={() => navigate('/siparisler')} style={{ marginBottom: 8 }}>← Siparişler</button>
          <h1 className="page-title mono">#{siparis.siparis_no}</h1>
          <p className="page-subtitle">{new Date(new Date(siparis.created_at).getTime() + 3 * 60 * 60 * 1000).toLocaleString('tr-TR')} • {siparis.firmalar?.ad}</p>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {/* BANKA — faturasız */}
          {siparis.odeme_durumu !== 'odendi' && siparis.odeme_turu !== 'kredi_karti' && !siparis.fatura_durumu && (
            <button className="btn btn-ghost btn-sm" onClick={whatsappLinkGonder} style={{ color: '#25D366', borderColor: '#25D366' }}>
              📱 Havale Linki Gönder
            </button>
          )}
          {/* BANKA — faturalı */}
          {siparis.odeme_durumu !== 'odendi' && siparis.odeme_turu !== 'kredi_karti' && siparis.fatura_durumu && (
            <button className="btn btn-ghost btn-sm" onClick={whatsappFaturaliHavaleGonder} style={{ color: '#25D366', borderColor: '#25D366' }}>
              🧾 Faturalı Havale Linki
            </button>
          )}
          {/* KREDİ KARTI — her ikisi de */}
          {siparis.odeme_durumu !== 'odendi' && siparis.odeme_turu === 'kredi_karti' && (
            <>
              <button className="btn btn-ghost btn-sm" onClick={() => { setKkLink(siparis.kk_odeme_linki || ''); setKkLinkModal(true); }} style={{ color: '#6366f1', borderColor: '#6366f1' }}>
                💳 KK Linki Gönder
              </button>
              <button className="btn btn-ghost btn-sm" onClick={whatsappFaturaliHavaleGonder} style={{ color: '#25D366', borderColor: '#25D366' }}>
                🧾 Banka Linki Gönder
              </button>
            </>
          )}
          {/* YENİ: ÜRÜN EKLE BUTONU */}
          {siparis.siparis_durumu !== 'iptal' && (
            <button className="btn btn-ghost btn-sm" onClick={urunModalAc} style={{ color: 'var(--accent)', borderColor: 'var(--accent)' }}>
              ➕ Ürün Ekle
            </button>
          )}
          {(profil?.rol === 'admin' || profil?.rol === 'super_admin' || profil?.rol === 'depocu') &&
            siparis.siparis_durumu !== 'teslim' && siparis.siparis_durumu !== 'iptal' && (
            <button className="btn btn-primary btn-sm" onClick={() => {
              const varsayilanFirma = kargoFirmalar.find(f => f.varsayilan) || kargoFirmalar[0];
              setKargoForm({
                kargo_kodu: siparis.kargo_kodu || '',
                elden_teslim: false,
                teslim_notu: '',
                kargo_firma_id: siparis.kargo_firma_id || varsayilanFirma?.id || '',
              });
              setKargoModal(true);
            }}>🚚 Kargo / Teslim</button>
          )}

          {!isTemsilci && (
            <button className="btn btn-ghost btn-sm" onClick={faturaDurumuGuncelle}>
              {siparis.fatura_durumu ? '✓ Fatura Kesildi' : '○ Fatura Kesilmedi'}
            </button>
          )}
          {(profil?.rol === 'admin' || profil?.rol === 'super_admin') && (
            <button className="btn btn-danger btn-sm" onClick={handleSil}>🗑 Sil</button>
          )}
          {siparis.odeme_durumu !== 'odendi' && (
            <button className="btn btn-primary btn-sm" onClick={() => {
              setOdemeForm({ tutar: siparis.toplam_tutar, odeme_turu: 'banka', not_: '' });
              setOdemeSekmesi('temsilci_yukle');
              setOdemeModal(true);
            }}>💳 Ödeme Al</button>
          )}
          {siparis.odeme_durumu === 'odendi' && (
            <button className="btn btn-ghost btn-sm" onClick={() => {
              setOdemeForm({ tutar: siparis.toplam_tutar, odeme_turu: 'banka', not_: '' });
              setOdemeSekmesi('temsilci_yukle');
              setOdemeModal(true);
            }}>📎 Ek Dekont Ekle</button>
          )}
        </div>
      </div>

      {/* DURUM GÜNCELLEME */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
          <span style={{ color: 'var(--text2)', fontSize: 13, marginRight: 4 }}>Sipariş Durumu:</span>
          {durumlar.map(d => (
            <button key={d} onClick={() => durumGuncelle(d)}
              className={`badge ${siparis.siparis_durumu === d ? durumRenk[d] : 'badge-gray'}`}
              style={{ border: 'none', cursor: 'pointer', padding: '6px 12px', fontSize: 12 }}>
              {d}
            </button>
          ))}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 320px', gap: 20 }}>
        <div>
          {/* SİPARİŞ KALEMLERİ */}
          <div className="card" style={{ marginBottom: 16, padding: 0 }}>
            <div style={{ padding: '14px 20px', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontWeight: 700 }}>Sipariş Kalemleri</span>
              {siparis.siparis_durumu !== 'iptal' && (
                <button className="btn btn-ghost btn-sm" onClick={urunModalAc} style={{ color: 'var(--accent)' }}>
                  ➕ Ürün Ekle
                </button>
              )}
            </div>
            <table className="table">
              <thead>
                <tr><th>Ürün</th><th>Miktar</th><th>Birim Fiyat</th>{altTemsilciOran === null && <th>Kom. %</th>}<th>Komisyon</th><th>Toplam</th><th></th></tr>
              </thead>
              <tbody>
                {kalemler.map(k => (
                  <tr key={k.id}>
                    <td>
                      <div style={{ fontWeight: 500 }}>{k.urunler?.ad}</div>
                      <div style={{ fontSize: 11, color: 'var(--text2)' }}>{k.urunler?.alt_grup || k.urunler?.grup}</div>
                    </td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        <span style={{ fontWeight: 600 }}>{k.miktar}</span>
                        <button className="btn btn-ghost btn-sm" style={{ padding: '1px 5px', fontSize: 10 }}
                          onClick={async () => {
                            const yeni = window.prompt('Yeni miktar:', k.miktar);
                            if (!yeni || parseInt(yeni) <= 0) return;
                            const yeniMiktar = parseInt(yeni);
                            const yeniToplam = (k.birim_fiyat || 0) * yeniMiktar;
                            const yeniKom = (k.komisyon_orani || 0) > 0 ? yeniToplam * ((k.komisyon_orani || 0) / 100) : 0;
                            await supabase.from('siparis_kalemleri').update({ miktar: yeniMiktar, toplam: yeniToplam, komisyon_tutari: yeniKom }).eq('id', k.id);
                            const { data: tK } = await supabase.from('siparis_kalemleri').select('toplam, komisyon_tutari, maliyet, miktar').eq('siparis_id', id);
                            const yT = (tK||[]).reduce((a,x)=>a+(x.toplam||0),0);
                            const yKom = (tK||[]).reduce((a,x)=>a+(x.komisyon_tutari||0),0);
                            const yM = (tK||[]).reduce((a,x)=>a+((x.maliyet||0)*(x.miktar||1)),0);
                            // Alt temsilci ise siparisler.toplam_komisyon = altPay olmalı
                            const altOranMiktar = altTemsilciOran !== null ? (altTemsilciOran / 100) : 1;
                            const yazilacakKom = yKom * altOranMiktar;
                            await supabase.from('siparisler').update({ toplam_tutar: yT, toplam_komisyon: yazilacakKom, toplam_maliyet: yM, net_kar: yT-yazilacakKom-yM }).eq('id', id);
                            // ust_temsilci_komisyonlar güncelle
                            if (altTemsilciOran !== null) {
                              const ustPay = yKom * ((100 - altTemsilciOran) / 100);
                              await supabase.from('ust_temsilci_komisyonlar').update({ toplam_komisyon: yKom, ust_temsilci_payi: ustPay, alt_temsilci_payi: yazilacakKom }).eq('siparis_id', id);
                            }
                            fetchData();
                          }}>✏️</button>
                      </div>
                    </td>
                    <td>{(k.birim_fiyat || 0).toLocaleString('tr-TR')} ₺</td>
                    {altTemsilciOran === null && <td style={{ color: 'var(--text2)' }}>%{k.komisyon_orani || 0}</td>}
                    <td style={{ color: 'var(--yellow)' }}>
                      {(altTemsilciOran !== null
                        ? (k.komisyon_tutari || 0) * (altTemsilciOran / 100)
                        : (k.komisyon_tutari || 0)
                      ).toLocaleString('tr-TR')} ₺
                    </td>
                    <td style={{ fontWeight: 700 }}>{(k.toplam || 0).toLocaleString('tr-TR')} ₺</td>
                    <td>
                      <button className="btn btn-danger btn-sm" style={{ padding: '2px 6px', fontSize: 11 }}
                        onClick={() => kalemSil(k.id, k.urun_id, k.miktar)}
                        title="Ürünü sil">🗑</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* MÜŞTERİ BİLGİLERİ */}
          <div className="card" style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h3 style={{ fontWeight: 700, margin: 0 }}>Müşteri & Teslimat</h3>
              <button className="btn btn-ghost btn-sm" onClick={() => {
                const mevcutNot = siparis.not_ || '';
                const temizNot = dekontlar.length > 0 && mevcutNot.includes('Dekont bekleniyor')
                  ? mevcutNot.replace(/\s*\|\s*Müşteri bilgileri iletildi\. Dekont bekleniyor\./g, '').replace(/Müşteri bilgileri iletildi\. Dekont bekleniyor\./g, '').trim()
                  : mevcutNot;
                setMusteriForm({
                  ad: siparis.musteriler?.ad || '',
                  telefon: siparis.musteriler?.telefon || '',
                  sehir: siparis.musteriler?.sehir || '',
                  ilce: siparis.musteriler?.ilce || '',
                  adres: siparis.musteriler?.adres || '',
                  siparis_adres: siparis.adres || '',
                  not_: temizNot,
                });
                setMusteriDuzenleModal(true);
              }}>✏️ Düzenle</button>
            </div>
            <div className="form-row cols-2">
              {[
                ['Müşteri', siparis.musteriler?.ad],
                ['Telefon', siparis.musteriler?.telefon],
                ['Şehir', siparis.musteriler?.sehir],
                ['Temsilci', siparis.kullanicilar ? `${siparis.kullanicilar.ad} ${siparis.kullanicilar.soyad}` : '-'],
                ['Depo', siparis.depolar?.ad],
                ['Ödeme Türü', siparis.odeme_turu === 'banka' ? 'Banka Havalesi' : siparis.odeme_turu === 'kredi_karti' ? 'Kredi Kartı' : 'Elden/Nakit'],
                ['KDV', siparis.kdv_durumu ? "KDV'li" : "KDV'siz"],
                ['Kargo Takip No', siparis.kargo_kodu || '-', true],
              ].map(([k, v]) => (
                <div key={k} style={{ marginBottom: 8 }}>
                  <div style={{ fontSize: 11, color: 'var(--text2)', marginBottom: 2 }}>{k}</div>
                  <div style={{ fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6 }}>
                    <span>{v || '-'}</span>
                    {k === 'Telefon' && (
                      <button className="btn btn-ghost btn-sm" style={{ fontSize: 10, padding: '1px 6px' }}
                        onClick={() => {
                          const yeniTel = window.prompt('Yeni telefon numarası:', siparis.musteriler?.telefon || '');
                          if (yeniTel !== null && yeniTel.trim()) {
                            supabase.from('musteriler').update({ telefon: yeniTel.trim() }).eq('id', siparis.musteri_id).then(() => fetchData());
                          }
                        }}>✏️</button>
                    )}
                    {k === 'Kargo Takip No' && (
                      <button className="btn btn-ghost btn-sm" style={{ fontSize: 10, padding: '1px 6px' }}
                        onClick={() => {
                          const yeniNo = window.prompt('Kargo takip numarası:', siparis.kargo_kodu || '');
                          if (yeniNo !== null) {
                            supabase.from('siparisler').update({ kargo_kodu: yeniNo.trim() }).eq('id', id).then(() => fetchData());
                          }
                        }}>✏️</button>
                    )}
                  </div>
                </div>
              ))}
            </div>
            {siparis.adres && <div style={{ marginTop: 8, padding: 10, background: 'var(--bg3)', borderRadius: 'var(--r)', fontSize: 13, color: 'var(--text2)' }}>{siparis.adres}</div>}
            {siparis.not_ && !(dekontlar.length > 0 && siparis.not_.includes('Dekont bekleniyor')) && (
              <div style={{ marginTop: 8, padding: 10, background: 'rgba(234,179,8,0.1)', borderRadius: 'var(--r)', fontSize: 13, color: 'var(--yellow)' }}>Not: {siparis.not_}</div>
            )}

            <div style={{ marginTop: 16, padding: 12, background: 'rgba(37,211,102,0.08)', border: '1px solid rgba(37,211,102,0.3)', borderRadius: 'var(--r)' }}>
                <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 6 }}>📎 Ödeme Linkleri</div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>

                  {/* KREDİ KARTI SİPARİŞİ — her ikisi de göster */}
                  {siparis.odeme_turu === 'kredi_karti' && (
                    <>
                      <code style={{ fontSize: 12, color: '#6366f1', flex: 1, wordBreak: 'break-all' }}>
                        {`${window.location.origin}/kk-odeme/${siparis.siparis_no}`}
                      </code>
                      {siparis.odeme_durumu !== 'odendi' && (
                        <>
                          <button className="btn btn-ghost btn-sm"
                            style={{ color: '#6366f1', borderColor: '#6366f1' }}
                            onClick={() => { setKkLink(siparis.kk_odeme_linki || ''); setKkLinkModal(true); }}>
                            💳 KK Linki Gönder
                          </button>
                          <button className="btn btn-ghost btn-sm"
                            style={{ color: '#25D366', borderColor: '#25D366' }}
                            onClick={whatsappFaturaliHavaleGonder}>
                            🧾 Banka Linki Gönder
                          </button>
                        </>
                      )}
                      {siparis.kk_odeme_linki && (
                        <span style={{ fontSize: 11, color: 'var(--green)', width: '100%' }}>✓ Sanal pos linki kayıtlı</span>
                      )}
                    </>
                  )}

                  {/* BANKA SİPARİŞİ */}
                  {siparis.odeme_turu !== 'kredi_karti' && (
                    <>
                      <code style={{ fontSize: 12, color: '#25D366', flex: 1, wordBreak: 'break-all' }}>
                        {siparis.fatura_durumu
                          ? `${window.location.origin}/faturali-havale/${siparis.siparis_no}`
                          : siparisLinki}
                      </code>
                      <button className="btn btn-ghost btn-sm"
                        onClick={() => navigator.clipboard.writeText(
                          siparis.fatura_durumu
                            ? `${window.location.origin}/faturali-havale/${siparis.siparis_no}`
                            : siparisLinki
                        )}>Kopyala</button>
                      {siparis.odeme_durumu !== 'odendi' && !siparis.fatura_durumu && (
                        <button className="btn btn-ghost btn-sm"
                          style={{ color: '#25D366', borderColor: '#25D366' }}
                          onClick={whatsappLinkGonder}>
                          📱 Havale Linki Gönder
                        </button>
                      )}
                      {siparis.odeme_durumu !== 'odendi' && siparis.fatura_durumu && (
                        <button className="btn btn-ghost btn-sm"
                          style={{ color: '#25D366', borderColor: '#25D366' }}
                          onClick={whatsappFaturaliHavaleGonder}>
                          🧾 Faturalı Havale Linki Gönder
                        </button>
                      )}
                    </>
                  )}

                  {/* KARGO TAKİP NO */}
                  {siparis.kargo_kodu && !siparis.kargo_kodu.startsWith('Elden') && (
                    <button className="btn btn-ghost btn-sm"
                      style={{ color: '#25D366', borderColor: '#25D366' }}
                      onClick={whatsappKargoGonder}>
                      🚚 Takip No Gönder
                    </button>
                  )}
                </div>
              </div>
          </div>

          {/* YÜKLENEN DEKONTLAR */}
          {dekontlar.length > 0 && (
            <div className="card">
              <h3 style={{ marginBottom: 12, fontWeight: 700 }}>Ödeme Dekontları</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {dekontlar.map(d => (
                  <div key={d.id} style={{ padding: 12, background: 'var(--bg3)', borderRadius: 'var(--r)', border: '1px solid var(--border)' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                      <span style={{ fontWeight: 600, color: 'var(--green)' }}>{(d.tutar || 0).toLocaleString('tr-TR')} ₺</span>
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                        <span style={{ fontSize: 12, color: 'var(--text2)' }}>{new Date(new Date(d.created_at).getTime() + 3 * 60 * 60 * 1000).toLocaleString('tr-TR')}</span>
                        {(!isTemsilci || d.created_by === profil?.id) && (
                          <button className="btn btn-danger btn-sm" style={{ padding: '2px 8px', fontSize: 11 }}
                            onClick={async () => {
                              if (!window.confirm('Bu dekontu silmek istediğinizden emin misiniz?')) return;
                              await supabase.from('odeme_dekontlari').delete().eq('id', d.id);
                              // Kalan dekont var mı kontrol et
                              const { data: kalanlar } = await supabase.from('odeme_dekontlari').select('id').eq('siparis_id', id);
                              if (!kalanlar || kalanlar.length === 0) {
                                await supabase.from('siparisler').update({ odeme_durumu: 'odenmedi' }).eq('id', id);
                              }
                              fetchData();
                            }}>Sil</button>
                        )}
                      </div>
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--text2)', marginBottom: d.dekont_url ? 8 : 0 }}>
                      {d.odeme_turu === 'banka' ? '🏦 Banka Havalesi' : d.odeme_turu === 'elden' ? '💵 Elden/Nakit' : '💳 Kredi Kartı'}
                      {d.not_ && ` • ${d.not_}`}
                    </div>
                    {d.dekont_url && (
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                        <a href={d.dekont_url} target="_blank" rel="noreferrer"
                          style={{ fontSize: 12, color: 'var(--accent)', textDecoration: 'none' }}>
                          📎 Dekontu Görüntüle
                        </a>
                        {d.dekont_url.match(/\.(jpg|jpeg|png|webp)$/i) && (
                          <img src={d.dekont_url} alt="dekont" style={{ height: 60, borderRadius: 4, border: '1px solid var(--border)', cursor: 'pointer' }}
                            onClick={() => window.open(d.dekont_url, '_blank')} />
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* SAĞ: ÖZET */}
        <div>
          <div className="card" style={{ marginBottom: 16 }}>
            <h3 style={{ marginBottom: 16, fontWeight: 700 }}>Finansal Özet</h3>
            {siparis.siparis_tipi === 'numune' ? (
              // Numune siparişi - sadece maliyet göster
              <>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border)' }}>
                  <span style={{ color: 'var(--text2)', fontSize: 13 }}>Toplam Tutar</span>
                  <span style={{ color: 'var(--text)', fontWeight: 700 }}>{(siparis.toplam_tutar || 0).toLocaleString('tr-TR')} ₺</span>
                </div>
                {!isTemsilci && (
                  <>
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border)' }}>
                      <span style={{ color: 'var(--text2)', fontSize: 13 }}>Maliyet</span>
                      <span style={{ color: 'var(--text2)' }}>{(siparis.toplam_maliyet || 0).toLocaleString('tr-TR')} ₺</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border)' }}>
                      <span style={{ color: 'var(--text2)', fontSize: 13 }}>Komisyon</span>
                      <span style={{ color: 'var(--text2)' }}>0 ₺</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
                      <span style={{ color: 'var(--text2)', fontSize: 13 }}>Net Kar</span>
                      <span style={{ color: 'var(--red)', fontWeight: 700 }}>-{(siparis.toplam_maliyet || 0).toLocaleString('tr-TR')} ₺</span>
                    </div>
                    <div style={{ marginTop: 8, padding: '6px 10px', background: 'rgba(139,92,246,0.1)', borderRadius: 'var(--r)', fontSize: 12, color: '#8b5cf6' }}>
                      🎁 Numune siparişi — komisyon hesaplanmaz
                    </div>
                  </>
                )}
              </>
            ) : (
              // Normal sipariş
              [
                ['Toplam Tutar', siparis.toplam_tutar, 'var(--text)', true],
                ...(!isTemsilci ? [['Maliyet', siparis.toplam_maliyet, 'var(--text2)', false]] : []),
                ['Komisyon', siparis.toplam_komisyon, 'var(--yellow)', false],
                ...(!isTemsilci ? [['Net Kar', siparis.net_kar, 'var(--green)', true]] : []),
              ].map(([k, v, renk, bold]) => (
                <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border)' }}>
                  <span style={{ color: 'var(--text2)', fontSize: 13 }}>{k}</span>
                  <span style={{ color: renk, fontWeight: bold ? 700 : 400 }}>{(v || 0).toLocaleString('tr-TR')} ₺</span>
                </div>
              ))
            )}
          </div>

          <div className="card">
            <h3 style={{ marginBottom: 12, fontWeight: 700 }}>Durum</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: 'var(--text2)', fontSize: 13 }}>Sipariş</span>
                <span className={`badge ${durumRenk[siparis.siparis_durumu]}`}>{siparis.siparis_durumu}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: 'var(--text2)', fontSize: 13 }}>Ödeme</span>
                <span className={`badge ${siparis.siparis_tipi === 'numune' ? '' : siparis.odeme_durumu === 'odendi' ? 'badge-green' : 'badge-red'}`}
                  style={siparis.siparis_tipi === 'numune' ? { background: 'rgba(139,92,246,0.15)', color: '#8b5cf6' } : {}}>
                  {siparis.siparis_tipi === 'numune' ? 'Bedelsiz' : siparis.odeme_durumu}
                </span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: 'var(--text2)', fontSize: 13 }}>Fatura</span>
                <span className={`badge ${siparis.fatura_durumu ? 'badge-green' : 'badge-red'}`}>{siparis.fatura_durumu ? 'Kesildi' : 'Kesilmedi'}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ─── ÜRÜN EKLEME MODAL ─── */}
      {urunModal && (
        <div className="modal-overlay" onClick={() => setUrunModal(false)}>
          <div className="modal" style={{ maxWidth: 700, maxHeight: '90vh', display: 'flex', flexDirection: 'column', width: '95vw' }} onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">➕ Siparişe Ürün Ekle — #{siparis.siparis_no}</h3>

            {ekSepet.length > 0 && (
              <div style={{ background: 'rgba(224,123,0,0.08)', border: '1px solid var(--accent)', borderRadius: 'var(--r)', padding: '8px 12px', marginBottom: 10 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                  <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--accent)' }}>🛒 {ekSepet.length} ürün</span>
                  <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--green)' }}>{ekSepet.reduce((a, { fiyat, miktar }) => a + fiyat * miktar, 0).toLocaleString('tr-TR')} ₺</span>
                </div>
                <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                  {ekSepet.map(({ sepetKey, urun, miktar, grup }) => (
                    <div key={sepetKey} style={{ display: 'flex', alignItems: 'center', gap: 4, background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 4, padding: '2px 8px', fontSize: 12 }}>
                      <span>{urun.ad} ×{miktar} <b style={{ color: grup === 'hasta_yakini' ? 'var(--purple)' : 'var(--accent)' }}>{grup === 'hasta_yakini' ? 'HY' : 'Vet'}</b></span>
                      <button style={{ border: 'none', background: 'none', color: 'var(--red)', cursor: 'pointer', fontSize: 12, padding: 0 }}
                        onClick={() => ekSepetMiktarGuncelle(sepetKey, 0)}>✕</button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
              <input className="input" placeholder="Ürün ara..." value={urunArama}
                onChange={e => setUrunArama(e.target.value)} style={{ flex: 1 }} autoFocus />
              <select className="select" style={{ maxWidth: 180 }} value={modalAltGrup}
                onChange={e => { setModalAltGrup(e.target.value); setUrunArama(''); }}>
                <option value="">Tüm Alt Gruplar</option>
                {[...new Set(tumUrunler.map(u => (u.alt_grup || 'Diğer').trim()))].sort().map(g => (
                  <option key={g} value={g}>{g}</option>
                ))}
              </select>
            </div>

            {urunHata && (
              <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 'var(--r)', padding: '8px 12px', color: 'var(--red)', fontSize: 13, marginBottom: 8 }}>
                {urunHata}
              </div>
            )}

            <div style={{ overflow: 'auto', flex: 1 }}>
              {altGruplar.map(grup => {
                const grupUrunleri = filtreliUrunler.filter(u => (u.alt_grup || 'Diğer').trim() === grup);
                return (
                  <div key={grup} style={{ marginBottom: 16 }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--accent)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 6 }}>
                      📂 {grup}
                    </div>
                    {grupUrunleri.map(u => {
                      const stok = stokMap[u.id];
                      const stokYok = siparis.depo_id && (stok === undefined || stok === 0);
                      const sepette = ekSepet.find(i => i.urun.id === u.id);
                      return (
                        <div key={u.id} style={{
                          padding: '8px 10px', borderRadius: 'var(--r)', marginBottom: 4,
                          background: sepette ? 'rgba(224,123,0,0.08)' : 'var(--bg3)',
                          border: `1px solid ${sepette ? 'var(--accent)' : 'var(--border)'}`,
                          opacity: stokYok ? 0.4 : 1,
                        }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ flex: 1 }}>
                              <div style={{ fontSize: 13, fontWeight: 500 }}>{u.ad}</div>
                              <div style={{ fontSize: 11, color: 'var(--text2)' }}>
                                {u.firmalar?.ad}
                                {siparis.depo_id && <span style={{ marginLeft: 8 }}>Stok: {stok ?? 0}</span>}
                              </div>
                              {/* Fiyat seçim butonları */}
                              {!stokYok && (
                                <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginTop: 6 }}>
                                  {siparis.firma_id === FIPGL23_ID ? (<>
                                    <button className="btn btn-primary btn-sm" style={{ fontSize: 11 }}
                                      onClick={() => ekSepeteEkleDetay(u, 'veteriner', 'banka')}>
                                      Vet. {(u.banka_fiyat_kdvsiz || 0).toLocaleString('tr-TR')} ₺
                                    </button>
                                    {u.satis_tipi === 'hepsi' && (
                                      <button className="btn btn-ghost btn-sm" style={{ fontSize: 11 }}
                                        onClick={() => ekSepeteEkleDetay(u, 'hasta_yakini', 'banka')}>
                                        HY {(u.hya_banka_fiyat || 0).toLocaleString('tr-TR')} ₺
                                      </button>
                                    )}
                                  </>) : siparis.firma_id !== BROILER_ID ? (<>
                                    <button className="btn btn-primary btn-sm" style={{ fontSize: 11 }}
                                      onClick={() => ekSepeteEkleDetay(u, 'veteriner', 'banka')}>
                                      Vet.Banka {(u.banka_fiyat_kdvsiz || 0).toLocaleString('tr-TR')} ₺
                                    </button>
                                    <button className="btn btn-ghost btn-sm" style={{ fontSize: 11, color: 'var(--yellow)', borderColor: 'var(--yellow)' }}
                                      onClick={() => ekSepeteEkleDetay(u, 'veteriner', 'kredi_karti')}>
                                      Vet.KK {(u.kk_fiyat_kdvli || 0).toLocaleString('tr-TR')} ₺
                                    </button>
                                    {u.satis_tipi === 'hepsi' && (<>
                                      <button className="btn btn-ghost btn-sm" style={{ fontSize: 11 }}
                                        onClick={() => ekSepeteEkleDetay(u, 'hasta_yakini', 'banka')}>
                                        HY.Banka {(u.hya_banka_fiyat || 0).toLocaleString('tr-TR')} ₺
                                      </button>
                                      <button className="btn btn-ghost btn-sm" style={{ fontSize: 11, color: 'var(--yellow)', borderColor: 'var(--yellow)' }}
                                        onClick={() => ekSepeteEkleDetay(u, 'hasta_yakini', 'kredi_karti')}>
                                        HY.KK {(u.hya_kk_fiyat || 0).toLocaleString('tr-TR')} ₺
                                      </button>
                                    </>)}
                                  </>) : (
                                    <button className="btn btn-primary btn-sm" style={{ fontSize: 11 }}
                                      onClick={() => ekSepeteEkle(u)}>
                                      + {birimFiyat(u).toLocaleString('tr-TR')} ₺
                                    </button>
                                  )}
                                </div>
                              )}
                              {stokYok && (
                                <span style={{ fontSize: 11, color: 'var(--red)', fontWeight: 600, marginTop: 4, display: 'block' }}>⛔ Stok Yok</span>
                              )}
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginLeft: 8 }}>
                              {sepette && (
                                <>
                                  <button className="btn btn-ghost btn-sm" style={{ padding: '4px 10px' }}
                                    onClick={() => ekSepetMiktarGuncelle(sepette.sepetKey, sepette.miktar - 1)}>−</button>
                                  <span style={{ minWidth: 24, textAlign: 'center', fontWeight: 700 }}>{sepette.miktar}</span>
                                  <button className="btn btn-ghost btn-sm" style={{ padding: '4px 10px' }}
                                    onClick={() => ekSepetMiktarGuncelle(sepette.sepetKey, sepette.miktar + 1)}>+</button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
              {filtreliUrunler.length === 0 && (
                <div style={{ textAlign: 'center', padding: 30, color: 'var(--text2)' }}>Ürün bulunamadı</div>
              )}
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16, paddingTop: 12, borderTop: '1px solid var(--border)' }}>
              <button className="btn btn-ghost" onClick={() => setUrunModal(false)}>İptal</button>
              <button className="btn btn-primary" onClick={ekUrunleriKaydet}
                disabled={ekSepet.length === 0 || urunYukleniyor}>
                {urunYukleniyor ? 'Kaydediliyor...' : `✓ ${ekSepet.length} Ürün Ekle`}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* KARGO MODAL */}
      {kargoModal && (
        <div className="modal-overlay" onClick={() => setKargoModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">Kargo / Teslim Bilgisi — #{siparis.siparis_no}</h3>
            <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
              <button className={`btn ${!kargoForm.elden_teslim ? 'btn-primary' : 'btn-ghost'} btn-sm`}
                onClick={() => setKargoForm(f => ({ ...f, elden_teslim: false }))}>🚚 Kargo ile Gönderim</button>
              <button className={`btn ${kargoForm.elden_teslim ? 'btn-primary' : 'btn-ghost'} btn-sm`}
                onClick={() => setKargoForm(f => ({ ...f, elden_teslim: true }))}>🤝 Elden Teslim</button>
            </div>
            {!kargoForm.elden_teslim ? (
              <>
                <div className="form-group">
                  <label className="label">Kargo Firması</label>
                  <select className="select" value={kargoForm.kargo_firma_id}
                    onChange={e => setKargoForm(f => ({ ...f, kargo_firma_id: e.target.value }))}>
                    <option value="">Seçin...</option>
                    {kargoFirmalar.map(f => (
                      <option key={f.id} value={f.id}>{f.ad}{f.varsayilan ? ' (Varsayılan)' : ''}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label className="label">Kargo Takip No</label>
                  <input className="input" value={kargoForm.kargo_kodu}
                    onChange={e => setKargoForm(f => ({ ...f, kargo_kodu: e.target.value }))}
                    placeholder="Kargo takip numarası..." />
                </div>
              </>
            ) : (
              <div className="form-group">
                <label className="label">Teslim Notu</label>
                <input className="input" value={kargoForm.teslim_notu}
                  onChange={e => setKargoForm(f => ({ ...f, teslim_notu: e.target.value }))}
                  placeholder="İstanbul Avrupa Depo / Ahmet Bey..." autoFocus />
              </div>
            )}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 8, flexWrap: 'wrap' }}>
              <button className="btn btn-ghost" onClick={() => setKargoModal(false)}>İptal</button>
              <button className="btn btn-primary" onClick={kargoGuncelle} disabled={kargoYukleniyor}>
                {kargoYukleniyor ? '⏳ Oluşturuluyor...' : kargoForm.elden_teslim ? '✓ Teslim Edildi' : '🚚 Kargoya Ver'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ÖDEME MODAL */}
      {odemeModal && (
        <div className="modal-overlay" onClick={() => setOdemeModal(false)}>
          <div className="modal" style={{ maxWidth: 520 }} onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">💳 Ödeme Al — #{siparis.siparis_no}</h3>
            <p style={{ color: 'var(--text2)', fontSize: 13, marginBottom: 16 }}>
              Tutar: <strong style={{ color: 'var(--text)' }}>{(siparis.toplam_tutar || 0).toLocaleString('tr-TR')} ₺</strong>
            </p>

            <div style={{ display: 'flex', gap: 6, marginBottom: 20, borderBottom: '1px solid var(--border)', paddingBottom: 12 }}>
              {[
                { id: 'temsilci_yukle', label: '📎 Dekont Yükle' },
                { id: 'nakit', label: '💵 Nakit / Elden' },
              ].map(s => (
                <button key={s.id}
                  className={`btn btn-sm ${odemeSekmesi === s.id ? 'btn-primary' : 'btn-ghost'}`}
                  style={{ flex: 1, justifyContent: 'center', fontSize: 13 }}
                  onClick={() => { setOdemeSekmesi(s.id); setDekontDosya(null); }}>
                  {s.label}
                </button>
              ))}
            </div>

            {odemeSekmesi === 'temsilci_yukle' && (
              <div>
                <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 16 }}>Müşteri WhatsApp'tan dekontu gönderdi. Aşağıdan yükleyin.</p>
                <div className="form-group">
                  <label className="label">Ödeme Türü</label>
                  <select className="select" value={odemeForm.odeme_turu}
                    onChange={e => setOdemeForm(f => ({ ...f, odeme_turu: e.target.value }))}>
                    <option value="banka">Banka Havalesi</option>
                    <option value="kredi_karti">Kredi Kartı</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="label">Dekont / Makbuz — Birden fazla seçebilirsiniz</label>
                  <div style={{ border: `2px dashed ${dekontDosyalar.length ? 'var(--accent)' : 'var(--border)'}`, borderRadius: 'var(--r)', padding: '24px', textAlign: 'center', cursor: 'pointer', background: dekontDosyalar.length ? 'rgba(224,123,0,0.06)' : 'var(--bg3)' }}
                    onClick={() => dosyaRef.current?.click()}
                    onDragOver={e => e.preventDefault()}
                    onDrop={e => { e.preventDefault(); setDekontDosyalar(f => [...f, ...Array.from(e.dataTransfer.files)]); }}>
                    {dekontDosyalar.length ? (
                      <div>
                        <div style={{ fontSize: 24, marginBottom: 4 }}>✓</div>
                        {dekontDosyalar.map((d, i) => (
                          <div key={i} style={{ fontWeight: 600, fontSize: 13 }}>{d.name} <span style={{ color: 'var(--text2)', fontWeight: 400 }}>({(d.size / 1024).toFixed(0)} KB)</span></div>
                        ))}
                        <div style={{ fontSize: 11, color: 'var(--accent)', marginTop: 6 }}>Daha fazla eklemek için tıkla</div>
                      </div>
                    ) : (
                      <div style={{ color: 'var(--text2)', fontSize: 13 }}><div style={{ fontSize: 28, marginBottom: 6 }}>📎</div>Dosyayı buraya sürükle veya tıkla<br/><span style={{ fontSize: 11 }}>Birden fazla seçebilirsiniz</span></div>
                    )}
                  </div>
                  <input ref={dosyaRef} type="file" accept="image/*,application/pdf" multiple style={{ display: 'none' }}
                    onChange={e => setDekontDosyalar(f => [...f, ...Array.from(e.target.files)])} />
                </div>
                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                  <button className="btn btn-ghost" onClick={() => setOdemeModal(false)}>İptal</button>
                  <button className="btn btn-ghost" onClick={() => temsilciDekontYukle(false)} disabled={!dekontDosyalar.length || yukleniyor} style={{ borderColor: 'var(--accent)', color: 'var(--accent)' }}>
                    {yukleniyor ? '⏳ Yükleniyor...' : '📎 Sadece Dekont Yükle'}
                  </button>
                  <button className="btn btn-primary" onClick={() => temsilciDekontYukle(true)} disabled={!dekontDosyalar.length || yukleniyor}>
                    {yukleniyor ? '⏳ Yükleniyor...' : `✓ Ödeme Alındı${dekontDosyalar.length > 1 ? ` (${dekontDosyalar.length} dekont)` : ''}`}
                  </button>
                </div>
              </div>
            )}

            {odemeSekmesi === 'nakit' && (
              <div>
                <div className="alert alert-warning" style={{ marginBottom: 16 }}>
                  ⚠️ "Ödeme Elden Alınmıştır — Sipariş No: {siparis.siparis_no}" olarak kaydedilecek.
                </div>
                <div className="form-group">
                  <label className="label">Alınan Tutar (₺)</label>
                  <input className="input" type="number" value={odemeForm.tutar}
                    onChange={e => setOdemeForm(f => ({ ...f, tutar: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label className="label">Nakit Makbuzu / Fotoğraf (isteğe bağlı)</label>
                  <div style={{ border: `2px dashed ${dekontDosya ? 'var(--accent)' : 'var(--border)'}`, borderRadius: 'var(--r)', padding: '24px', textAlign: 'center', cursor: 'pointer', background: dekontDosya ? 'rgba(224,123,0,0.06)' : 'var(--bg3)' }}
                    onClick={() => dosyaRef.current?.click()}
                    onDragOver={e => e.preventDefault()}
                    onDrop={e => { e.preventDefault(); const f = e.dataTransfer.files[0]; if (f) setDekontDosya(f); }}>
                    {dekontDosya ? (
                      <div><div style={{ fontSize: 24, marginBottom: 4 }}>✓</div><div style={{ fontWeight: 600 }}>{dekontDosya.name}</div><div style={{ fontSize: 12, color: 'var(--text2)' }}>{(dekontDosya.size / 1024).toFixed(0)} KB</div></div>
                    ) : (
                      <div style={{ color: 'var(--text2)', fontSize: 13 }}><div style={{ fontSize: 28, marginBottom: 6 }}>📸</div>Makbuz fotoğrafı (isteğe bağlı)</div>
                    )}
                  </div>
                  <input ref={dosyaRef} type="file" accept="image/*,application/pdf" style={{ display: 'none' }}
                    onChange={e => setDekontDosya(e.target.files[0])} />
                </div>
                <div className="form-group">
                  <label className="label">Ek Not (isteğe bağlı)</label>
                  <input className="input" value={odemeForm.not_}
                    onChange={e => setOdemeForm(f => ({ ...f, not_: e.target.value }))} placeholder="Ek not..." />
                </div>
                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                  <button className="btn btn-ghost" onClick={() => setOdemeModal(false)}>İptal</button>
                  <button className="btn btn-primary" onClick={nakitOdemeKaydet} disabled={yukleniyor}>
                    {yukleniyor ? 'Kaydediliyor...' : '✓ Nakit Ödeme Alındı'}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {musteriDuzenleModal && (
        <div className="modal-overlay" onClick={() => setMusteriDuzenleModal(false)}>
          <div className="modal" style={{ maxWidth: 500 }} onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">Müşteri & Teslimat Düzenle</h3>
            <div className="form-group">
              <label className="label">Ad Soyad / Hasta Yakını Adı</label>
              <input className="input" value={musteriForm.ad}
                onChange={e => setMusteriForm(f => ({ ...f, ad: e.target.value }))} autoFocus />
            </div>
            <div className="form-group">
              <label className="label">Telefon</label>
              <input className="input" value={musteriForm.telefon}
                onChange={e => setMusteriForm(f => ({ ...f, telefon: e.target.value }))} />
            </div>
            <div className="form-group">
              <label className="label">Şehir / İlçe</label>
              <SehirIlceSecici
                sehir={musteriForm.sehir}
                ilce={musteriForm.ilce}
                onSehirChange={v => setMusteriForm(f => ({ ...f, sehir: v }))}
                onIlceChange={v => setMusteriForm(f => ({ ...f, ilce: v }))}
              />
            </div>
            <div className="form-group">
              <label className="label">Müşteri Kayıtlı Adresi</label>
              <textarea className="textarea" value={musteriForm.adres}
                onChange={e => setMusteriForm(f => ({ ...f, adres: e.target.value }))}
                placeholder="Müşterinin kayıtlı adresi..." />
            </div>
            <div className="form-group">
              <label className="label">Sipariş Teslimat Adresi</label>
              <textarea className="textarea" value={musteriForm.siparis_adres}
                onChange={e => setMusteriForm(f => ({ ...f, siparis_adres: e.target.value }))}
                placeholder="Bu siparişe özel teslimat adresi..." />
            </div>
            <div className="form-group">
              <label className="label">Sipariş Notu</label>
              <textarea className="textarea" value={musteriForm.not_}
                onChange={e => setMusteriForm(f => ({ ...f, not_: e.target.value }))}
                placeholder="Sipariş notu..." />
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn btn-ghost" onClick={() => setMusteriDuzenleModal(false)}>İptal</button>
              <button className="btn btn-primary" onClick={musteriDuzenleKaydet}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
      {/* KK ÖDEME LİNKİ MODAL */}
      {kkLinkModal && (
        <div className="modal-overlay" onClick={() => setKkLinkModal(false)}>
          <div className="modal" style={{ maxWidth: 500 }} onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">💳 KK Ödeme Linki — #{siparis.siparis_no}</h3>
            <div style={{ background: 'rgba(99,102,241,0.1)', border: '1px solid rgba(99,102,241,0.3)', borderRadius: 'var(--r)', padding: 12, marginBottom: 16 }}>
              <p style={{ fontSize: 13, color: 'var(--text2)', margin: 0, lineHeight: 1.6 }}>
                Banka/sanal pos panelinizden ödeme linki oluşturun ve aşağıya yapıştırın.
                Link müşteriye WhatsApp ile gönderilecek ve <strong style={{ color: 'var(--text)' }}>24 saat</strong> geçerli olacaktır.
              </p>
            </div>
            <div className="form-group">
              <label className="label">Sanal Pos Ödeme Linki *</label>
              <input
                className="input"
                value={kkLink}
                onChange={e => setKkLink(e.target.value)}
                placeholder="https://odeme.banka.com.tr/..."
                autoFocus
              />
            </div>
            <div style={{ background: 'rgba(234,179,8,0.1)', border: '1px solid rgba(234,179,8,0.3)', borderRadius: 'var(--r)', padding: 10, marginBottom: 16 }}>
              <p style={{ fontSize: 12, color: 'var(--yellow)', margin: 0 }}>
                ⚠️ Müşteriye gönderilecek sayfada bu link "Kredi Kartı ile Öde" butonu olarak görünecektir.
              </p>
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn btn-ghost" onClick={() => setKkLinkModal(false)}>İptal</button>
              <button className="btn btn-primary" style={{ background: '#6366f1', borderColor: '#6366f1' }}
                onClick={kkLinkKaydetVeGonder} disabled={!kkLink.trim()}>
                💳 Kaydet ve WhatsApp ile Gönder
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
